/*
 * @Descripttion:
 * @version:
 * @Author: shenlin
 * @Date: 2021-11-30 16:21:00
 * @LastEditors: shenlin
 * @LastEditTime: 2021-11-30 16:29:40
 */
export const liveTypeList = {
  1: '法律专题',
  2: '企业家培训专题',
  3: '安全生产专题',
  4: '党建专题',
  5: '政策解读',
  6: '会议直播',
  7: '技术分享',
  8: '企业分享',
  9: '活动直播',
  10: '赛事专区',
  11: '信息服务',
  12: '投融资服务',
  13: '创业服务',
  14: '人才培训',
  15: '培训服务',
  16: '技术创新和质量服务',
  17: '数字化赋能服务',
  18: '管理咨询',
  19: '市场开拓',
  20: '法律服务',
  21: '其他'
}
